import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';

import { Component, Input } from '@angular/core';
import { ButtonModule } from 'primeng/button';

import { disputeCreditNoteLinks, relativeTimeLabel } from '../dispute.utils';

import { StaffDisputeDetail } from '../../services/staff-dispute.service';
import { OrderNavigationService } from '../../services/order-navigation.service';

import { DisputeStatusBadgeComponent } from './dispute-status-badge.component';



@Component({

    selector: 'app-dispute-summary-header',

    standalone: true,

    imports: [CommonModule, CurrencyPipe, DatePipe, ButtonModule, DisputeStatusBadgeComponent],

    template: `

        <div class="detail-header" *ngIf="detail">

            <div class="detail-title-row">

                <h2 class="claim-title">{{ detail.claimNumber }}</h2>

                <app-dispute-status-badge [status]="detail.status"></app-dispute-status-badge>

                <span class="submitted-at">{{ submittedLabel }}</span>

            </div>



            <div class="summary-grid">

                <div class="mini-card">

                    <span class="mini-label">Order ID</span>

                    <span class="mini-value">{{ detail.orderNumber }}</span>

                </div>

                <div class="mini-card">

                    <span class="mini-label">Invoice No.</span>

                    <span class="mini-value">{{ detail.invoiceNumber || '—' }}</span>

                </div>

                <div class="mini-card">

                    <span class="mini-label">Customer</span>

                    <span class="mini-value">{{ detail.customerName || detail.customerId || '—' }}</span>

                </div>

                <div class="mini-card">

                    <span class="mini-label">Qty</span>

                    <span class="mini-value">{{ detail.totalClaimQty || 0 }}</span>

                </div>

                <div class="mini-card">

                    <span class="mini-label">Claim Amount</span>

                    <span class="mini-value amount">{{

                        detail.totalClaimAmountEur != null

                            ? (detail.totalClaimAmountEur | currency: 'EUR' : 'symbol' : '1.2-2')

                            : '—'

                    }}</span>

                </div>

                <div class="mini-card">

                    <span class="mini-label">Created On</span>

                    <span class="mini-value">{{ detail.createdAt | date: 'MMM d, y, h:mm a' }}</span>

                </div>

            </div>

            <div class="credit-notes-section" *ngIf="creditNotes.length">

                <h3 class="credit-notes-title">Credit note orders</h3>

                <ul class="credit-notes-list">

                    <li *ngFor="let cn of creditNotes" class="credit-note-row">
                        <button
                            type="button"
                            class="cn-order-link"
                            (click)="viewCreditNoteOrder(cn.creditNoteOrderNumber)"
                        >
                            {{ cn.creditNoteOrderNumber }}
                        </button>
                        <span class="cn-type">{{ cn.creditNoteOrderType }}</span>
                        <span class="cn-date" *ngIf="cn.createdAt">
                            {{ cn.createdAt | date: 'MMM d, y, h:mm a' }}
                        </span>
                        <p-button
                            label="View order"
                            icon="pi pi-external-link"
                            [text]="true"
                            size="small"
                            styleClass="cn-view-btn"
                            (onClick)="viewCreditNoteOrder(cn.creditNoteOrderNumber)"
                        ></p-button>
                    </li>

                </ul>

            </div>

        </div>

    `,

    styles: [

        `

            .detail-header {

                background: var(--dispute-card, var(--surface-card));

                border: 1px solid var(--dispute-border, var(--surface-border));

                border-radius: 12px;

                padding: 1rem 1.25rem;

                box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);

            }

            .detail-title-row {

                display: flex;

                align-items: center;

                flex-wrap: wrap;

                gap: 0.65rem;

                margin-bottom: 1rem;

            }

            .claim-title {

                margin: 0;

                font-size: 1.35rem;

                font-weight: 700;

            }

            .submitted-at {

                color: var(--dispute-muted, var(--text-color-secondary));

                font-size: 0.85rem;

            }

            .summary-grid {

                display: grid;

                grid-template-columns: repeat(6, minmax(0, 1fr));

                gap: 0.65rem;

            }

            @media (max-width: 1100px) {

                .summary-grid {

                    grid-template-columns: repeat(3, minmax(0, 1fr));

                }

            }

            @media (max-width: 640px) {

                .summary-grid {

                    grid-template-columns: repeat(2, minmax(0, 1fr));

                }

            }

            .mini-card {

                background: var(--dispute-nested-bg, var(--surface-secondary));

                border: 1px solid var(--dispute-border, var(--surface-border));

                border-radius: 8px;

                padding: 0.6rem 0.75rem;

                display: flex;

                flex-direction: column;

                gap: 0.15rem;

                min-width: 0;

            }

            .mini-label {

                font-size: 0.65rem;

                color: var(--dispute-muted, var(--text-color-secondary));

                text-transform: uppercase;

                letter-spacing: 0.03em;

            }

            .mini-value {

                font-weight: 600;

                font-size: 0.88rem;

                word-break: break-word;

            }

            .mini-value.amount {

                color: var(--dispute-primary, var(--primary-color));

            }

            .credit-notes-section {

                margin-top: 1rem;

                padding-top: 0.85rem;

                border-top: 1px solid var(--dispute-border, var(--surface-border));

            }

            .credit-notes-title {

                margin: 0 0 0.5rem;

                font-size: 0.8rem;

                font-weight: 600;

                text-transform: uppercase;

                letter-spacing: 0.03em;

                color: var(--dispute-muted, var(--text-color-secondary));

            }

            .credit-notes-list {

                list-style: none;

                margin: 0;

                padding: 0;

                display: flex;

                flex-direction: column;

                gap: 0.35rem;

            }

            .credit-note-row {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                gap: 0.5rem 1rem;
                font-size: 0.88rem;
            }

            .cn-order-link {
                font-weight: 600;
                font-family: ui-monospace, monospace;
                padding: 0;
                border: none;
                background: none;
                color: var(--dispute-primary, var(--primary-color));
                cursor: pointer;
                text-decoration: underline;
                text-underline-offset: 2px;
            }

            .cn-order-link:hover {
                opacity: 0.85;
            }

            :host ::ng-deep .cn-view-btn {
                padding: 0.15rem 0.35rem;
                font-size: 0.8rem;
            }

            .cn-type,
            .cn-date {
                color: var(--dispute-muted, var(--text-color-secondary));
                font-size: 0.8rem;
            }

        `

    ]

})

export class DisputeSummaryHeaderComponent {

    @Input({ required: true }) detail!: StaffDisputeDetail | null;

    constructor(private readonly orderNavigation: OrderNavigationService) {}

    viewCreditNoteOrder(orderNumber: string): void {
        const trimmed = (orderNumber || '').trim();
        if (!trimmed) {
            return;
        }
        this.orderNavigation.navigateToItemDetails(trimmed, { fromDisputeReview: true });
    }

    get submittedLabel(): string {

        if (!this.detail?.createdAt) return '';

        return `Submitted ${relativeTimeLabel(this.detail.createdAt)}`;

    }

    get creditNotes() {

        return disputeCreditNoteLinks(this.detail);

    }

}


